import {Alert, Button, Input, Space, Typography} from 'antd'
import {useState} from 'react'
import {useAppSelector} from '../../../store/hooks'
import {userSelector} from '../../../store/global'
import {updateEmail} from '../../../shared/http/user'
import NotificationsUtils from '../../utils/NotificationsUtils'
import {NavigationPages} from '../../../common/navigation/navigation-pages'
import {isRussianUser} from '../../../common/utils/geo'

const {Link} = Typography

const EMAIL_BANNER_DISMISSED_KEY = 'email_warning_banner_dismissed'

const EmailWarningBanner = () => {
    const user = useAppSelector(userSelector)
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [emailSent, setEmailSent] = useState(false)
    const [dismissed, setDismissed] = useState(
        () => localStorage.getItem(EMAIL_BANNER_DISMISSED_KEY) === 'true'
    )

    if (!user || user.email || dismissed || !isRussianUser()) {
        return null
    }

    const handleSave = () => {
        if (!email || !email.includes('@')) {
            NotificationsUtils.openErrorNotification('Введите корректный email')
            return
        }
        setLoading(true)
        updateEmail(email)
            .then(() => {
                setEmailSent(true)
            })
            .catch(() => {
                NotificationsUtils.openErrorNotification('Не удалось сохранить email')
            })
            .finally(() => setLoading(false))
    }

    const handleDismiss = () => {
        localStorage.setItem(EMAIL_BANNER_DISMISSED_KEY, 'true')
        setDismissed(true)
    }

    if (emailSent) {
        return (
            <Alert
                type="success"
                banner
                closable
                onClose={handleDismiss}
                message={`Письмо с подтверждением отправлено на ${email}. Проверьте почту и перейдите по ссылке.`}
            />
        )
    }

    return (
        <Alert
            type="warning"
            banner
            closable
            onClose={handleDismiss}
            message={
                <Space direction="vertical" style={{width: '100%'}}>
                    <span>
                        Вход через Google может стать недоступен. Укажите email, чтобы не потерять доступ к аккаунту.
                        При проблемах — <Link href={NavigationPages.CONTACTS}>напишите нам</Link>.
                    </span>
                    <Space>
                        <Input
                            placeholder="Ваш email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onPressEnter={handleSave}
                            style={{width: 250}}
                        />
                        <Button type="primary" loading={loading} onClick={handleSave}>
                            Сохранить
                        </Button>
                    </Space>
                </Space>
            }
        />
    )
}

export default EmailWarningBanner
